import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsOneCardExpressAdminStatusChangeParm } from "./wsOneCardExpressAdminStatusChangeParm";

@Injectable()
export class DataService_expressadmin {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminSchoolsGet
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminSchoolsGet() {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressAdminSchoolsGet";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminDataGet
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminDataGet(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressAdminDataGet";

		var promise$ = this.httpclientService.post(url, SchoolID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminPrintQueueStatusSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminPrintQueueStatusSelectList() {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressAdminPrintQueueStatusSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OneCardExpressAdminStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	OneCardExpressAdminStatusChange(parms: wsOneCardExpressAdminStatusChangeParm) {
		var postResult$ = new Subject();
		var url = "OneCardExpress/OneCardExpressAdminStatusChange";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PublicTransitPreferenceSelect
	//
	//-----------------------------------------------------------------------------------------------------
	PublicTransitPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/PublicTransitPreferenceSelect";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
